import { createContext } from 'react';
import { VendingMachineLinks } from '../VmLocationContainer';

export const InternalLinkModContext = createContext<{
  vendingMachineLinks: VendingMachineLinks;
}>({
  vendingMachineLinks: {
    links: [],
    title: ''
  }
});

type OwnProps = {
  children: React.ReactNode;
  internalLinks: { vendingMachineLinks: VendingMachineLinks };
};

export default function InternalLinkModProvider({
  children,
  internalLinks
}: OwnProps) {
  return (
    <InternalLinkModContext.Provider value={internalLinks}>
      {children}
    </InternalLinkModContext.Provider>
  );
}
